import { PortalVerticalGameTilePropTypes } from '@/types/gameTypes';
import { ShuffleWidgetTile } from '@/types/shuffleWidgetTypes';

export const getShuffleGamesProperties = ({
  shuffleGamesTile,
  game,
}: {
  shuffleGamesTile: ShuffleWidgetTile;
  game?: PortalVerticalGameTilePropTypes;
}) => {
  return {
    type: shuffleGamesTile.type,
    staticTexts: {
      shuffle: shuffleGamesTile.staticTexts.shuffle,
      shuffleDescription: shuffleGamesTile.staticTexts.shuffleDescription,
      shuffleAgain: shuffleGamesTile.staticTexts.shuffleAgain,
      play: shuffleGamesTile.staticTexts.play,
    },
    icon: shuffleGamesTile.icon,
    sprites: shuffleGamesTile.sprites,
    behaviour: shuffleGamesTile.behaviour,
    limit: shuffleGamesTile.limit,
    uid: shuffleGamesTile.uid,
    game: game,
  };
};
